const defaults = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease",
};

export { defaults };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/defaults.es.js
// module id = 3Yh3
// module chunks = 0